import { render, staticRenderFns } from "./shuiwu.vue?vue&type=template&id=910df676&scoped=true&"
import script from "./shuiwu.vue?vue&type=script&lang=js&"
export * from "./shuiwu.vue?vue&type=script&lang=js&"
import style0 from "./shuiwu.vue?vue&type=style&index=0&id=910df676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910df676",
  null
  
)

export default component.exports